<div class="notes-container">
  <!-- Notes List -->
  <div class="notes-list" *ngIf="notes.length > 0">
    <div class="note-item" *ngFor="let note of notes">
      <div class="note-header">
        <span class="note-date">{{ note.createdDate | date:'MM/dd/yyyy h:mm a' }}</span>
        <span class="note-user">{{ note.createdBy }}</span>
      </div>
      <div class="note-content">
        {{ note.content }}
      </div>
    </div>
  </div>

  <div class="empty-notes" *ngIf="notes.length === 0">
    <mat-icon>note</mat-icon>
    <p>No notes available</p>
  </div>

  <!-- Add New Note -->
  <div class="add-note-section">
    <h3>Add New Note</h3>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Note content</mat-label>
      <textarea
        matInput
        [(ngModel)]="newNoteContent"
        [maxlength]="maxCharacters"
        rows="4"
        placeholder="Enter your note here...">
      </textarea>
      <mat-hint align="end">{{ getRemainingCharacters() }} / {{ maxCharacters }} characters remaining</mat-hint>
    </mat-form-field>
    <div class="note-actions">
      <!-- Notes are always internal; checked also posts to the registrant's portal Messages. -->
      <mat-checkbox color="primary" [(ngModel)]="sendToRegistrant">Send to registrant</mat-checkbox>
      <button
        mat-raised-button
        color="primary"
        (click)="publishNote()"
        [disabled]="!canPublish()">
        <mat-icon>publish</mat-icon>
        PUBLISH NOTE
      </button>
    </div>
  </div>
</div>
